export interface SavedPlanner {
  selected: Record<string, boolean>;
  servings: Record<string, number>;
  mealTime: string;
  shoppingChecked: string[];
}

export const DEFAULT_MEAL_TIME = "18:30";
export const PLANNER_STORAGE_KEY = "yukai-v1-planner";
export const PLANNER_UPDATED_EVENT = "yukai-planner-updated";

export function readPlanner(): SavedPlanner {
  try {
    const saved = JSON.parse(localStorage.getItem(PLANNER_STORAGE_KEY) ?? "{}") as Partial<SavedPlanner>;
    return {
      selected: saved.selected ?? {},
      servings: saved.servings ?? {},
      mealTime: /^\d{2}:\d{2}$/.test(saved.mealTime ?? "") ? saved.mealTime! : DEFAULT_MEAL_TIME,
      shoppingChecked: Array.isArray(saved.shoppingChecked)
        ? saved.shoppingChecked.filter((item): item is string => typeof item === "string")
        : [],
    };
  } catch {
    return { selected: {}, servings: {}, mealTime: DEFAULT_MEAL_TIME, shoppingChecked: [] };
  }
}

export function writePlanner(value: SavedPlanner): void {
  localStorage.setItem(PLANNER_STORAGE_KEY, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent(PLANNER_UPDATED_EVENT));
}

export function plannerSelectionCount(): number {
  return Object.values(readPlanner().selected).filter(Boolean).length;
}
